import { useMemo } from 'react';
import { NewsArticle } from '../components/category/types';

interface UseCategoryNewsProps {
  newsArticles: NewsArticle[];
  categoryId: string;
}

export const useCategoryNews = ({ newsArticles, categoryId }: UseCategoryNewsProps) => {
  const categoryNews = useMemo(() => {
    // Mapeo de categorías para relacionar con noticias
    const categoryMapping: { [key: string]: string[] } = {
      'textil': ['textil', 'moda', 'industria'],
      'muebles': ['muebles', 'decoración', 'hogar'],
      'herrerias': ['herrería', 'metalurgia', 'artesanía'],
      'griferia': ['plomería', 'instalación', 'hogar'],
      'ferreteria': ['ferretería', 'herramientas', 'bricolaje'],
      'aberturas': ['aberturas', 'construcción', 'hogar'],
      'maquinaria': ['maquinaria', 'industria', 'equipos'],
      'herramientas': ['herramientas', 'bricolaje', 'técnica'],
      'arquitectos': ['arquitectura', 'diseño', 'construcción'],
      'mm-obra': ['construcción', 'obra', 'maestros'],
      'gestores': ['gestión', 'inmobiliaria', 'administración'],
      'constructoras': ['construcción', 'desarrollo', 'inmobiliaria']
    };

    const relatedCategories = categoryMapping[categoryId] || [];
    
    return newsArticles.filter(article => 
      relatedCategories.some(cat => 
        article.category.includes(cat) || 
        article.tags.some(tag => tag.includes(cat))
      )
    ).slice(0, 8); // Máximo 8 noticias (4 técnicas + 4 de color)
  }, [newsArticles, categoryId]);

  return categoryNews;
};
